<div class="entity-header">
  <ion-icon [name]="icon" class="entity-icon" aria-hidden="true" />
  <span class="entity-title">{{ title }}</span>
  @if (badgeLabel) {
  <span class="entity-badge" [class.entity-badge--warning]="badgeVariant === 'warning'">{{ badgeLabel }}</span>
  }
</div>
